<template>
  <div>
    <b-card title="Conteúdo">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-content-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
     <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        v-b-modal.update-api-cache-modal
      ><feather-icon icon="RefreshCwIcon" /> Atualizar Api Cache</b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
    <b-modal
      ref="update-api-cache-modal"
      id="update-api-cache-modal"
      modal-class="modal-primary"
      title="Atualizar Api Cache"
      ok-title="Adicionar"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <b-row>
          <b-col md="12">
            <label for="sync-params-logical-number">Origem</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.origin"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="origins"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-button
            class="btn-sm btn-nav-link btn-nav-link-white"
            size="sm"
            variant="flat-primary"
            :disabled="isSyncing"
            @click="updateApiCache"
          >
            <feather-icon v-if="!isSyncing" icon="RefreshCwIcon" />
            <b-spinner v-if="isSyncing" small />
            {{ isSyncing ? "Atualizando..." : "Atualizar" }}
          </b-button>
        </b-row>        
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BButton, BRow, BCol } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import contentService from "@/providers/contentService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from '@/providers/dropdownService';
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    BRow,
    BCol,
    BButton,
    vSelect,
    // CustomFilter
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filterFields: [
        { id: 'filter-name', placeholder: 'Nome', type: 'text', inputType: 'text', model: 'name' },
        { id: 'filter-origin', placeholder: 'Origem', type: 'list', inputType: '', model: 'origin', list: 'filter-list-origin', array: [] },
      ],
      filter: {},
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      tableLoading: true,
      fields: [
        // { field: "_id", label: "ID", sortable: false },
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "code", label: "Código", sortable: true, filterOptions: { filterValue: '', enabled: true, numeric: true, placeholder: 'Pesquisar por código', trigger: 'enter' } },
        { field: "namePtBr", label: "Nome PT-BR", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome pt-br', trigger: 'enter' } },
        { field: "nameEnEu", label: "Nome EN-EU", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome en-eu', trigger: 'enter' } },
        { field: "nameEsEs", label: "Nome ES-ES", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome es-es', trigger: 'enter' } },
        { field: "nameEsAr", label: "Nome ES-AR", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome es-ar', trigger: 'enter' } },
        { field: "namePtPt", label: "Nome PT-PT", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome pt-pt', trigger: 'enter' } },
        { field: "nameZhCn", label: "Nome ZH-CN", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome zh-cn', trigger: 'enter' } },
        { field: "order", label: "Ordem", sortable: false },
        { field: "icon", label: "Icone", sortable: false },
        { field: "origin", label: "Origem", type: "array", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Habilitado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
      ],
      origins: []
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Conteúdos');
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append('page', this.page);
      params.append('limit', this.limit);
      
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    updateApiCache() {
      const params = new URLSearchParams();
      if (this.syncParamsForm.origin) {
        params.append('originCode', this.syncParamsForm.origin.code);
      }
      contentService
        .updateApiCache(params)
        .then((response) => {
          this.isSyncing = false;
          console.log(response);
          this.$refs['update-api-cache-modal'].hide();
          messagesNotifyHelper.successNotify(
            "Api Cache",
            "Atualização feita com sucesso"
          );
        })
        .catch((err) => {
          this.isSyncing = false;
          console.log(err);
        });
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      contentService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'conteudo.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService.getAllOrigin(new URLSearchParams())
      .then(res => {
        // this.origins = res;
        // this.filterFields[this.filterFields.findIndex(item => item.id=='filter-origin')].array = this.origins;
        const origins = res.map(item => {
          return { value: item.id, text: item.name };
        });
        this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
        this.syncParamsForm.origin = res.find(item => item.code == 250);
        this.setInitialTableFilters();
      })
      .catch(err => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_CONTENT_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      contentService
        .deleteContent(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', contentService.getAllContent(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>